module.exports = __webpack_public_path__ + "static/img/loading.c2645e5f.gif";